import type { LocaleStrings } from "../types.ts";

export const esLocale: LocaleStrings = {
  game: {
    defaultClanName: "Tu clan",
    clanSetupTitle: "Crea tu clan",
    clanSetupNameLabel: "Nombre del clan",
    clanSetupNamePlaceholder: "Introduce un nombre",
    clanSetupConfirm: "Confirmar",
    settleConfirm: "Continuar",
    promptConfirmStart: "¿Empezar aquí?",
    startTileConfirm: "Confirmar",
    startTileCancel: "Cancelar",
    clanSetupTotemLabel: "Tótem",
    promptClanSetup: "Pon nombre a tu clan, elige un tótem y confirma para elegir la casilla inicial.",
    statsHeaderFormat: "{clanName} · {turnLabel} {turn}",
    promptSelectStart: "Elige dónde debe empezar tu clan.",
    promptClanEstablished: "Clan establecido.",
    promptEndTurn: "Termina tu turno cuando estés listo.",
    promptNewTurn: "Muévete a una casilla adyacente o termina tu turno.",
    promptVictory: "¡Tu clan prospera!",
    promptDefeat: "Tu clan tiene hambre.",
    tileContentsFormat: "{terrain} — {food} comida/turno",
    tileContentsReducedFormat: "{terrain} — {effective}/{base} comida/turno",
    tileTravelingFormat: "{terrain} — viajando, sin cosecha este turno",
    turnLabel: "Turno",
    dayNightLabels: {
      day: "Día",
      dusk: "Atardecer",
      night: "Noche",
      dawn: "Amanecer",
    },
    seasonLabels: {
      spring: "Primavera",
      summer: "Verano",
      autumn: "Otoño",
      winter: "Invierno",
    },
    temperatureFormat: "{value}°C",
    weatherLabels: {
      clear: "Despejado",
      cloudy: "Nublado",
      overcast: "Cubierto",
      rainy: "Lluvia",
      snowy: "Nieve",
    },
    populationLabel: "Población",
    foodLabel: "Comida",
    waterLabel: "Agua",
    ambientPredatorsLabel: "Depredadores",
    ambientPredatorLevelLabels: {
      none: "Ninguno",
      low: "Bajo",
      medium: "Medio",
      high: "Alto",
    },
    populationProgressFormat: "{current} / {max}",
    foodGrowthHintFormat: "→ crecimiento en {threshold}",
    statsCollapsedChipFormat: "Turno {turn} · {population} · {food} · {water} · {predators}",
    endTurnLabel: "Fin del turno",
    terrainNames: {
      ["desert"]: "Desierto",
      ["mountain"]: "Montaña",
      ["swamp"]: "Pantano",
      ["forest"]: "Bosque",
      ["plains"]: "Llanura",
      ["river"]: "Río",
    },
    totemNames: {
      carved: "Tallado",
      antler: "Astas",
      spiral: "Espiral",
    },
    victoryTitle: "¡Victoria!",
    victoryMessage: "Tu clan ha llegado a 30 personas. Comienza una verdadera civilización.",
    victoryRecapLineFormat: "{label}: {value}",
    victoryRecapTurns: "Turnos hasta la victoria",
    victoryRecapPopulation: "Población",
    victoryRecapFood: "Comida",
    victoryRecapStartTerrain: "Terreno inicial",
    victoryRecapEndTerrain: "Terreno final",
    victoryRecapExplored: "Mapa explorado",
    victoryRecapExploredFormat: "{explored} / {total} casillas",
    defeatTitle: "Derrota",
    defeatMessage: "Los últimos de tu gente han desaparecido.",
    startAgain: "Empezar de nuevo",
    resetLabel: "Reiniciar",
    exitGame: "Salir del juego",
    settingsTitle: "Ajustes",
    settingsCloseAriaLabel: "Cerrar ajustes",
    languageLabel: "Idioma",
    sfxVolumeLabel: "Efectos de sonido — {level}",
    debugModeOff: "Modo debug desactivado",
    debugModeOn: "Modo debug activado",
    fullscreenOff: "Pantalla completa desactivada",
    fullscreenOn: "Pantalla completa activada",
    foodOverlayOff: "Mostrar comida en el mapa",
    foodOverlayOn: "Ocultar comida en el mapa",
    waterOverlayOff: "Mostrar agua en el mapa",
    waterOverlayOn: "Ocultar agua en el mapa",
    promptBannerHide: "Ocultar banner de instrucciones",
    promptBannerShow: "Mostrar banner de instrucciones",
    stagingBadgeLabel: "Staging",
    hudSettingsTooltip: "Abrir ajustes",
    hudNotificationsTooltip: "Abrir notificaciones",
    notificationMarkDone: "Marcar como hecha",
    notificationOk: "OK",
    notificationCancel: "Cancelar",
    closeAriaLabel: "Cerrar",
    leaveConfirmTitle: "¿Guardar y salir?",
    leaveConfirmBody:
      "Se guardará tu progreso. Podrás continuar esta partida desde la pantalla de inicio.",
    leaveConfirmSave: "Guardar y salir",
    leaveConfirmStay: "Seguir jugando",
    leaveConfirmSaveFailed:
      "No se pudo guardar la partida. Libera espacio en el navegador e inténtalo de nuevo.",
    notificationEmpty: "No hay notificaciones ahora.",
    notificationPageOf: "{current} / {total}",
    notificationPageIndicatorOf: "({current} / {total})",
    notificationSwampTitle: "Pantano",
    notificationSwampBody: "Tu clan ha entrado en un pantano. El terreno está encharcado y avanzar aquí cuesta más.",
    notificationFireTitle: "Fuego descubierto",
    notificationFireBody:
      "Tu clan ha encontrado fuego en esta casilla—un hallazgo poco común al explorar el mapa.",
    notificationFoodDepletionTitle: "Tierra agotada",
    notificationFoodDepletionBody:
      "Permanecer en la misma casilla reduce su comida. Muévete y deja que la tierra se recupere con el tiempo.",
    notificationTutorialTurnsTitle: "Tu primer turno",
    notificationTutorialTurnsBody:
      "Muévete a una casilla adyacente, o termina tu turno cuando estés listo.",
    notificationTutorialStatsTitle: "Estadísticas del clan",
    notificationTutorialStatsBody:
      "El panel arriba a la izquierda muestra turno, hora del día, estación, temperatura, clima, población, comida, agua y depredadores en tu casilla. Pulsa E o Terminar turno cuando estés listo para recolectar y avanzar.",
    notificationTutorialWinGoalTitle: "Cómo ganar",
    notificationTutorialWinGoalBody:
      "Haz crecer tu clan hasta 30 personas para ganar. Si la población cae a cero, el clan se pierde.",
    notificationTutorialFoodEconomyTitle: "Comida cada turno",
    notificationTutorialFoodEconomyBody:
      "Al terminar el turno, la casilla produce comida. La población come primero—el resto se suma o resta de las reservas.",
    notificationTutorialTileFoodTitle: "Leer una casilla",
    notificationTutorialTileFoodBody:
      "Cada casilla revelada muestra terreno y comida por turno. Explora antes de asentarte—casillas fértiles como llanuras y ríos alimentan más tiempo.",
    notificationTutorialGrowthTitle: "Crecimiento",
    notificationTutorialGrowthBody:
      "Cuando las reservas se mantienen altas varios turnos seguidos, la población crece en uno.",
    notificationTutorialFamineTitle: "Hambre",
    notificationTutorialFamineBody:
      "Si el clan pasa hambre demasiado tiempo, pierdes una persona. Muévete a casillas fértiles y acumula reservas.",
    notificationTutorialOneMoveTitle: "Moverse cada turno",
    notificationTutorialOneMoveBody:
      "Pulsa 1–6 o haz clic en una casilla adyacente resaltada por turno, o quédate. Quedarte demasiado agota la tierra.",
    notificationTutorialFoodOverlayTitle: "Comida en el mapa",
    notificationTutorialFoodOverlayBody:
      "Pulsa F o usa el botón del grano en el HUD para ver la comida en casillas reveladas sin abrirlas una a una.",
    notificationTutorialLandRecoveryTitle: "La tierra se recupera",
    notificationTutorialLandRecoveryBody:
      "Las casillas que dejas recuperan comida con el tiempo. Sigue moviéndote para no agotar un solo lugar.",
    notificationTutorialSettingsTitle: "Ajustes",
    notificationTutorialSettingsBody:
      "Pulsa S o abre el engranaje para cambiar idioma, ajustar efectos de sonido, activar pantalla completa, reiniciar o volver a la pantalla de inicio.",
    notificationTutorialRandomEventsTitle: "Eventos en el mapa",
    notificationTutorialRandomEventsBody:
      "Pueden aparecer eventos inesperados al explorar. Pulsa N o abre la campana para leer qué ocurrió.",
    languageLabels: {
      en: "Inglés",
      it: "Italiano",
      fr: "Francés",
      es: "Español",
      pt: "Portugués",
      de: "Alemán",
      zh: "Chino",
      nl: "Neerlandés",
    },
  },
  site: {
    gameTitle: "Dawn of Clans",
    kofiButtonLabel: "Apóyame en Ko-fi",
    discordLinkLabel: "Unirse a Discord",
    landing: {
      primaryDescription:
        "Dawn of Clans es un juego de gran estrategia en el que guías a un clan prehistórico a través de la supervivencia, el descubrimiento y la evolución social.",
      secondaryDescription:
        "Empezando con un pequeño grupo nómada, desbloquearás tecnologías con la experiencia, adaptarás a entornos cambiantes y darás forma al surgimiento de las primeras civilizaciones.",
      earlyAccessLabel: "Acceso anticipado",
      earlyAccessNotice:
        "En desarrollo temprano. El bucle de supervivencia básico es jugable hoy; llegarán sistemas estratégicos más profundos.",
      learnMoreLabel: "Más información",
      releaseNoticeText: "¡Acaba de salir una nueva versión!",
      playLabel: "Jugar",
      continueLabel: "Continuar",
      savedGameSummary: "Turno {turn}, Población {population}",
      resumeModalTitle: "Partida guardada",
      newGameLabel: "Nueva partida",
      loadingLabel: "Cargando...",
      changelogLink: "Novedades",
      careerTeaserFormat:
        "{wins} victorias · récord: {fastest} turnos · más explorado: {explored}",
      careerViewChronicleLabel: "Ver crónica de victorias",
      chronicleModalTitle: "Crónica de victorias",
      chronicleModalCloseLabel: "Cerrar",
      chronicleEntryFormat: "{clanName} · {turns} turnos · {date}",
      chronicleClearWinHistoryLabel: "Borrar historial de victorias",
      chronicleClearWinHistoryBody:
        "Elimina todas las victorias guardadas en este dispositivo. La partida en curso no se modifica.",
      chronicleClearWinHistoryConfirm: "Sí, borrar historial",
      chronicleClearWinHistoryCancel: "Cancelar",
      settingsGearAriaLabel: "Ajustes",
      settingsCloseAriaLabel: "Cerrar ajustes",
    },
    about: {
      pageTitle: "Sobre Dawn of Clans",
      backLinkLabel: "← Volver a Dawn of Clans",
      sections: [
        {
          heading: "Resumen",
          body: "Dawn of Clans es un juego de gran estrategia en el que guías a un clan prehistórico a través de la supervivencia, el descubrimiento y la evolución social. Empezando con un pequeño grupo nómada, desbloquearás tecnologías con la experiencia, adaptarás a entornos cambiantes y darás forma al surgimiento de las primeras civilizaciones.",
        },
        {
          heading: "Tu clan",
          body: "Al empezar una partida nueva, ponle nombre a tu clan y elige dónde asentarte en el mapa hexagonal. Tras fundar tu primer asentamiento, controla turno, población y comida en el panel de estadísticas. Termina cada turno para alimentar tu clan y decide si mueves a una casilla adyacente antes del siguiente turno.",
        },
        {
          heading: "Progresión",
          body: "Cada terreno produce una cantidad distinta de comida cada turno. Cuando tus reservas se mantienen altas varios turnos seguidos, tu población crece; si tu clan pasa demasiado tiempo con hambre, se pierde gente. Acumula reservas en casillas fértiles como ríos y llanuras, luego haz crecer tu clan hasta treinta personas para ganar. Si la población llega a cero, el clan desaparece.",
        },
        {
          heading: "El mundo",
          body: "Explora un mapa hexagonal donde las casillas empiezan ocultas. Haz clic para revelar desierto, montaña, pantano, bosque, llanura y río. Elige dónde establecer tu primer asentamiento y luego muévete una casilla adyacente por turno. Las tierras fértiles alimentan más bocas; las tierras hostiles agotan tus reservas rápido.",
        },
        {
          heading: "Estado",
          body: "Dawn of Clans está en desarrollo temprano. Exploración, asentamiento, comida y población por turnos, y victoria o derrota son jugables hoy. Sistemas estratégicos más profundos siguen en construcción.",
        },
      ],
      communitySection: {
        heading: "Comunidad",
        body: "Chatea con otros jugadores, comparte comentarios y sigue las novedades del desarrollo en nuestro servidor de Discord.",
      },
      supportSection: {
        heading: "Apoya el proyecto",
        body: "¿Te gusta Dawn of Clans? Las donaciones opcionales en Ko-fi ayudan a financiar el desarrollo.",
      },
    },
    changelog: {
      pageTitle: "Novedades",
      backLinkLabel: "← Volver a Dawn of Clans",
      loadError: "No se pudo cargar el historial.",
      emptyState: "Aún no hay versiones publicadas.",
    },
  },
};
